import axios from 'axios';
import { useState,useEffect} from 'react';
import Error from './Error';
function About({Headerkey}){
   const [sprachen,setSprachen]=useState([]);
   const [sonstigues,setSonstigues]=useState([]);
   const [error,setError]=useState();
   useEffect( () => { 
                      const  fetchResult =async ()  =>{
                        
                                        // get tata using axios
                                       
                                      await axios.get("https://api.jsonbin.io/v3/b/5f99459330aaa01ce619fa72/1",
                                                            { headers:{'X-Access-Key':Headerkey},
                                                            Accept: 'application/json',
                                                              method:"GET"}).then(async (Result)=>{
                                                                setSprachen(Result.data.record.Sprachen.Sprache);
                                                                setSonstigues(Result.data.record.Sprachen.Sonstiges);
                                                              }).catch(async (err)=>{ setError(err.response.data.message); console.error(err);});
                                                  
                                    
                          
                                  }
                                  if(sprachen.length===0 || sprachen.length===undefined || sonstigues.length===0 || sonstigues.length===undefined ) {const timeoutID=setTimeout(()=>{fetchResult();},3000); 
                                       return()=>{clearTimeout(timeoutID)};
                                    }      
     
                    },[Headerkey,sonstigues.length,sprachen.length]);
                   
                    if (error) {
                      return(<div className=" bg-red-100 px-20 right-1/2 rounded-xl text-2xl w-full" > <Error error={error}></Error> </div>);
                      }
        return (<>
                  <div > <div className='zwichen text-2xl'>Sprachen:</div></div>
                   <table className="table2">
            
                          {sprachen.map((sprache,index)=>{
                          return(<tbody key={index}>
                            <tr className="bis2 border-b border-blue-300 ">
                               <td className="px-6 py-4">
                                 {sprache}
                              </td>
                            
                            </tr>
                          </tbody>)})}
                
                    </table>

   
         <div className="zwichen text-2xl"> Sonstiges:</div>
        <table className="table2">
                {sonstigues.map((etwas,index)=>
                                              {
                                                    return(
                                                            <tbody key={index}>
                                                                <tr className="border-b border-blue-300 bg-slate-600 text-slate-300 dark:text-slate-50">
                                                                  <td className="bis2 px-6 py-4">
                                                                  {etwas}
                                                                  </td>
                                                                
                                                                </tr>
                                                            </tbody>
                                                          )
                                              }
                                  )
                  }

           </table>
   
   
   
   
   </>) ;

}
export default About